import React from 'react';
import { GoogleApiWrapper, InfoWindow, Map, Marker } from 'google-maps-react';
import ReactDOM from "react-dom";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
// import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import '../../HotelMaterial.css'
import Link from '@material-ui/core/Link';
// import { Button } from '@material-ui/core';


const GOOGLE_MAPS_JS_API_KEY = 'AIzaSyCWCu2mMfPB0twxHyFuvk6mbB-o_bBqITM';

class GoogleMapsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {}
        }

            // binding this to event-handler functions
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.onMapClick = this.onMapClick.bind(this);
    }

     capitalizarPalabras = (val) => {
        if (typeof val === "undefined" || val === "") {
          return "";
        } else {
          try {
            return val
              .toLowerCase()
              .trim()
              .split(" ")
              .filter((item) => item.trim() !== "")
              .map((v) => v[0].toUpperCase() + v.substr(1))
              .join(" ");
          } catch (error) {
            console.error("errortoUpper");
            console.error(error);
          }
        }
      }

    ApplyFilterName = () => {
        console.log("this.state.hotelNombre")
        console.log(this.state.hotelNombre)
        this.props.onClick(this.state.hotelNombre)
    }

    onInfoWindowOpen(props, e) {
            const button = ( <Link href="#" onClick={e => {this.ApplyFilterName();}} color="inherit">{this.state.hotelNombre}</Link>);
            // <button onClick={e => {this.ApplyFilterName();}}>mapbutton</button>);
            if (document.getElementById("iwc") != null ) {
            ReactDOM.render(React.Children.only(button), document.getElementById("iwc"));
        }
      }

    onMarkerClick = (props, marker, e) => {
        console.log(this.props.dataHotelsDetails[0])
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true,
            hotelNombre: marker.hotelNombre,
            hotelDireccion: marker.hotelDireccion,
            hotelCodigo: marker.hotelCodigo,
        });
    }
    onMapClick = (props) => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null,
                hotelCodigo: '',
                hotelDireccion: '',
                hotelNombre: '', 
            });
        }
    }
    render() {

        const style = {
            /*    width: '50vw',
               height: '75vh', */
            width: '960px',
            height: '700x'
        }

        const containerStyle = {
            width: '100%',
            height: '620px'
        }

        const styleDiv = {
            /*    width: '50vw',
               height: '75vh', */
            width: '960px',
            height: '700px',
            overflow: 'hidden'
        }
/*         const styleDivBar = {
                width: '960px',
            height: '64px',
            overflow: 'hidden'
        } */

        const appBar = {
            position: 'relative',
            backgroundColor: '#FE5215'
        }

        const TituloHotel = {
            color: 'white'
        }

        const hotelMarker = {
            color: '#016AA2',
            fontWeight: 'bolder'
        }

/*         const Address = {
            fontStyle: 'oblique'
        } */

      
        return (
            <div style={styleDiv}>
                <AppBar style={appBar}>
                    <Toolbar>
                        <Typography variant="h6" style={TituloHotel}>
                            Hoteles disponibles en <span><img src={this.props.countryFlag} width="20px"></img></span> {this.props.zoneName}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Map
                    containerStyle={containerStyle}
                    item
                    xs={12}
                    style={style}
                    google={this.props.google}
                    onClick={this.onMapClick}
                    zoom={12}
                    scroll='body'
                    initialCenter={{
                        lat: this.props.dataHotelsDetails.filter(s => s.Latitud !== '' || s.Longitud !== '')[0].Latitud,
                        lng: this.props.dataHotelsDetails.filter(s => s.Latitud !== '' || s.Longitud !== '')[0].Longitud
                    }}
                >
                    {this.props.dataHotelsDetails.map((hotel, i) =>
                        (hotel.Latitud !== '' || hotel.Longitud !== '') ?
                                <Marker
                                    key={i}
                                    onClick={this.onMarkerClick}
                                    hotelCodigo={hotel.hotelOperador}
                                    hotelDireccion={hotel.Direccion}
                                    hotelNombre={hotel.hotelNombre}
                                    position={{ lat: hotel.Latitud, lng: hotel.Longitud }}
                                    name={hotel.hotelOperador}
                                />
                            : ''
                    )}
                    <InfoWindow
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                        onOpen={e => {
                            this.onInfoWindowOpen(this.props, e);
                          }}
                    >
                        <Paper>
                        <Link href="#" onClick={this.ApplyFilterName}>
                            <Typography
                                component='h5'
                                style={hotelMarker}
                            >
                                 <div id="iwc" />
                                {/* {this.state.hotelNombre} */}
                            </Typography>
                        </Link>
                            <Typography
                                component='body1'
                            >
                                <br />
                                {this.capitalizarPalabras(this.state.hotelDireccion)} 
                                
                                {/* {this.state.hotelCodigo} */}
                            </Typography>
                           
                          {/* <Button onClick={this.ApplyFilterName}>JG</Button>  */}
                        </Paper>
                    </InfoWindow>
                </Map>
            </div >
        );
    }
}
/* export default GoogleApiWrapper({
  api: (GOOGLE_MAPS_JS_API_KEY)
})(GoogleMapsContainer) */

export default GoogleApiWrapper(props => ({
    apiKey: GOOGLE_MAPS_JS_API_KEY,
}))(GoogleMapsContainer);